import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PosterPublishingOptionsPanelProps} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {isUserPremium} from '@Libraries/user.library';

export const openPublishingOptionsModal = (props: PosterPublishingOptionsPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PUBLISHING_OPTIONS_MODAL,
      panelProps: props,
    })
  );
};

export const openPublishingModalWithPosterHashedId = (posterHashedId: string): void => {
  openPublishingOptionsModal({
    panelDetails: {
      displayType: DisplayType.MODAL,
    },
    idPosterHash: posterHashedId,
    isPosterMaker: window.PMW.isReactPosterMaker() ? 1 : 0,
    preselectPaidProduct: window.PMW.isEmbedded() && isUserPremium(),
    isPremium: window.posterEditor?.whiteboard?.getCurrentPage().isPremium() ? 1 : 0,
    posterType: window.posterEditor?.whiteboard?.type.name,
    idGalleryTemplate: window.posterEditor?.whiteboard?.idGalleryTemplate,
    idTemplate: window.posterEditor?.whiteboard?.idTemplate,
    uc: window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges() ? 1 : 0,
    isVideo: window.posterEditor?.whiteboard?.isVideo() ? 1 : 0,
    hasVideoItem: window.posterEditor?.whiteboard?.getCurrentPage().items.hasVideoItem() ? 1 : 0,
    isExpensiveVideo: window.posterEditor?.whiteboard?.getCurrentPage().isExpensiveVideo() ? 1 : 0,
    isTransparent: window.posterEditor?.whiteboard?.getCurrentPage().isTransparent() ? 1 : 0,
    hasClickableLink: window.posterEditor?.whiteboard?.getCurrentPage().items.hasClickableItem() ? 1 : 0,
    pw: window.posterEditor?.whiteboard?.width,
    ph: window.posterEditor?.whiteboard?.height,
    ptw: window.posterEditor?.whiteboard?.userWidth,
    pth: window.posterEditor?.whiteboard?.userHeight,
    ptu: window.posterEditor?.whiteboard?.units,
  });
};
